<div>
  <button
    flat
    id="left-carousel-btn"
    class="carousel-btn icon-btn left-carousel-btn"
    [ngClass]="[carouselName + '-left-btn']"
    (click)="scrollCarouselContainer('left')"
  >
    <span class="sif sif-left-arrow-outline"></span>
  </button>
  <button
    flat
    class="carousel-btn icon-btn right-carousel-btn"
    id="right-carousel-btn"
    (click)="scrollCarouselContainer('right')"
  >
    <span class="sif sif-right-arrow-outline"></span>
  </button>
</div>
